import { Stepper, StepLabel, Step } from '@material-ui/core';

import styled from 'styled-components';

import { mediaQueries, fontFamily } from '../../../../libs';

export const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
`;

export const StepperHeader = styled(Stepper)`
  padding: 5px !important;
  background: inherit !important;

  svg {
    font-size: 30px;
    color: #00000030;
  }

  @media (max-width: ${mediaQueries.smDefault}px) {
    flex: 1;
    padding: 0 0 5px 0 !important;

    svg {
      font-size: 18px;
    }

    .makeStyles-root-97 {
      width: 30px;
      height: 30px;
    }
  }
`;

export const StepStyled = styled(Step)`
  padding: 0 !important;
  width: 65px;
`;

export const StepLabelStyled = styled(StepLabel)`
  .MuiStepLabel-label {
    color: ${({ theme }) => theme?.colors?.headerHover ?? '#00000030'} !important;
  }

  .MuiStepLabel-active {
    color: ${({ theme }) => theme?.colors?.headerText}!important;
  }

  .MuiStepLabel-completed {
    color: ${({ theme }) => theme?.colors?.headerText}90 !important;
  }

  span > span {
    margin: 0 !important;
    font-size: 8px !important;
    font-family: ${fontFamily} !important;
    font-weight: bold !important;
  }
`;

export default {};
